import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
//Commons
import { ActionReportPageComponent } from './components/routes/action-report/action-report.component';
import { ActivationStepsComponent } from './components/routes/activation-steps/activation-steps.component';
//Pages
import { FirstEmisPageComponent } from './components/routes/activation-steps/first-emis/first-emis.component';
import { ForcePWDPageComponent } from './components/routes/activation-steps/force-pwd/force-pwd.component';
import { CertificatePageComponent } from './components/routes/certificate/certificate.component';
import { ErrorPageComponent } from './components/routes/error/error.component';
import { EsgComponent } from './components/routes/esg/esg.component';
import { HomePageComponent } from './components/routes/homepage/homepage.component';
import { LoginPageComponent } from './components/routes/login/login.component';
import { BccFederationComponent } from './components/routes/bcc/bcc.component';
import { ManageCertComponent } from './components/routes/manage-cert/manage-cert.component';
import { MultiCertComponent } from './components/routes/multi-cert/multi-cert.component';
import { Oauth2Component } from './components/routes/oauth2/oauth2.component';
import { OtpPageComponent } from './components/routes/otp/otp.component';
import { VirtualTokenComponent } from './components/routes/otp/virtual-token/virtual-token.component';
import { PinPageComponent } from './components/routes/pin/pin.component';
import { RenewSuccessComponent } from './components/routes/renew/renew-success/renew-success.component';
import { RenewPageComponent } from './components/routes/renew/renew.component';
import { ReportPageComponent } from './components/routes/report/report.component';
import { SuspendPageComponent } from './components/routes/suspend/suspend.component';
import { TestPageComponent } from './components/routes/test/test.component';
import { AuthGuard } from './guards/Auth.guard';

const routes: Routes = [
  {
    path: 'bcc',
    component: BccFederationComponent,
  },
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'activation-steps',
        component: ActivationStepsComponent,
        data: {
          breadcrumb: 'HEADER.MYSIGN',
        },
        children: [
          { path: '1', component: ForcePWDPageComponent },
          { path: '2', component: FirstEmisPageComponent },
        ],
      },
      {
        path: 'homepage',
        component: HomePageComponent,
        data: {
          isHomepage: true,
          breadcrumb: 'COMMON.HOMEPAGE_LINK',
        },
      },
      // Route fittizia non utilizzata nel flusso di navigazione reale.
      // Serve esclusivamente per forzare l'inclusione della chiave di traduzione 'HEADER.HOMEPAGE'
      // all'interno del sistema di traduzione dei breadcrumb (ngx-translate + xng-breadcrumb).
      // Questo consente di rendere disponibile la traduzione nel flusso di `TranslateService.stream()`,
      // anche se la rotta 'homepage' non attiva direttamente xng-breadcrumb.
      {
        path: 'breadcrumb-placeholder',
        component: HomePageComponent,// componente qualsiasi, non sarà mai raggiunto
        data: {
          breadcrumb: 'HEADER.HOMEPAGE',
        },
      },
      {
        path: 'multi-cert',
        component: MultiCertComponent,
        data: {
          breadcrumb: 'MULTI_CERT_PAGE.TITLE',
        },
      },
      {
        path: 'cert',
        component: CertificatePageComponent,
        data: {
          breadcrumb: 'HOMEPAGE.CERT.TITLE',
        },
      },
      {
        path: 'otp',
        data: {
          breadcrumb: 'HOMEPAGE.OTP.TITLE',
        },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: OtpPageComponent,
            data: {
              breadcrumb: 'HOMEPAGE.OTP.TITLE',
            },
          },

          {
            path: 'tokens',
            component: VirtualTokenComponent,
            data: {
              breadcrumb: 'HOMEPAGE.VIRTUAL.TITLE',
            },
          },
        ],
      },
      {
        path: 'otp/tokens',
        component: VirtualTokenComponent,
        data: {
          breadcrumb: 'HOMEPAGE.VIRTUAL.TITLE',
        },
      },
      {
        path: 'actionReport',
        component: ActionReportPageComponent,
        data: {
          breadcrumb: 'HOMEPAGE.ACTION_REPORT.TITLE',
        },
      },
      {
        path: 'report',
        component: ReportPageComponent,
        data: {
          breadcrumb: 'HOMEPAGE.REPORT.TITLE',
        },
      },
      {
        path: 'pin',
        component: PinPageComponent,
        data: {
          breadcrumb: 'HOMEPAGE.PIN.TITLE',
        },
      },
      {
        path: 'renew',
        component: RenewPageComponent,
        data: {
          breadcrumb: 'HOMEPAGE.RENEW.TITLE',
        },
      },
      {
        path: 'renew/success',
        component: RenewSuccessComponent,
        data: {
          breadcrumb: 'HOMEPAGE.RENEW.TITLE',
        },
      },
      {
        path: 'suspend',
        component: SuspendPageComponent,
        data: {
          breadcrumb: 'HOMEPAGE.SUSPEND.TITLE',
        },
      },
      {
        path: 'manageCert',
        component: ManageCertComponent,
        data: {
          breadcrumb: 'HOMEPAGE.MANAGE_CERT.TITLE',
        },
      },
      {
        path: 'esg',
        component: EsgComponent,
        data: {
          breadcrumb: 'HOMEPAGE.ESG.TITLE',
        },
      },
    ],
  },
  {
    path: 'login',
    component: LoginPageComponent,
  },
  {
    path: 'oauth2',
    component: Oauth2Component,
  },
  {
    path: 'test',
    component: TestPageComponent,
  },
  {
    path: 'error',
    component: ErrorPageComponent,
  },
  {
    path: '**',
    redirectTo: 'oauth2',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers: [AuthGuard],
})
export class AppRoutingModule {}
